import { render, staticRenderFns } from "./patientCard.vue?vue&type=template&id=ed65a542&scoped=true&"
import script from "./patientCard.vue?vue&type=script&lang=js&"
export * from "./patientCard.vue?vue&type=script&lang=js&"
import style0 from "./patientCard.vue?vue&type=style&index=0&id=ed65a542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed65a542",
  null
  
)

export default component.exports